'use client';

import { GetExperiencesFromCatgRes } from '@/actions/experiences/types';
import { getRegionByLocale } from '@/components/SicilyPages/utils';
import useGlobalContext from '@/hooks/useGlobalContext';
import { normalizeRegion } from '@/utils/normalizeRegion';
import { useParams } from 'next/navigation';
import { useEffect } from 'react';

export function ExperienceCategorySetDynamicUrls({
  category,
}: {
  category: NonNullable<GetExperiencesFromCatgRes['macroCategory']>;
}) {
  const { setDynamicUrl, setIsDynamicUrl } = useGlobalContext();
  const params = useParams();

  const normalizedRegion = normalizeRegion(params.region as string);

  const categorySlugs = category.categoryTranslation.reduce(
    (acc: Record<string, string>, { locale, slug }) => {
      let path;
      const region = getRegionByLocale(normalizedRegion, locale);
      switch (locale) {
        case 'it':
          path = `/it/${region}/esperienze/${slug}/`;
          break;
        case 'de':
          path = `/de/${region}/erfahrungen/${slug}/`;
          break;
        case 'fr':
          path = `/fr/${region}/experiences/${slug}/`;
          break;
        default:
          path = `/${region}/experiences/${slug}/`;
      }

      acc[locale] = path;
      return acc;
    },
    {},
  );

  useEffect(() => {
    setIsDynamicUrl(true);
    setDynamicUrl(categorySlugs);

    return () => {
      setIsDynamicUrl(false);
      setDynamicUrl({
        it: '',
        en: '',
        de: '',
        fr: '',
      });
    };
    // eslint-disable-next-line
  }, []);

  return null;
}
